<template>
    <div class="flowShop">
        <dataAnalysisTemplate
            :echoData="echoData"
            :showData="crowdPortrait"
            @save="save"
            :viewData="viewData"
        ></dataAnalysisTemplate>
    </div>
</template>

<script>
import dataAnalysisTemplate from './dataAnalysisTemplate';
import { getDataAnalysisInfo } from '../../../../utils/apis';

export default {
    name: 'flowShop',
    components: {
        dataAnalysisTemplate,
    },
    data() {
        return {
            viewData: {},
            crowdPortrait: 'flowShop',
            echoData: {},
        };
    },
    methods: {
        save(val) {
            this.$emit('save', 3, val);
        },
        async getDataAnalysisInfoFn() {
            let res = await getDataAnalysisInfo({
                type: 3,
            });
            this.echoData = res.data;
        },
    },
    mounted() {
        this.getDataAnalysisInfoFn();
    },
};
</script>

<style scoped>
.flowShop {
    width: 100%;
    height: 100%;
}
</style>
